var _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccordion = function SvgAccordion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.35 17.11a1 1 0 0 1-.69 1.2l-2.82.78a2 2 0 0 1-2.41-1.36L.82 8.3a2 2 0 0 1 1.37-2.41L5 5.11a1 1 0 0 1 1.21.68zm-5.18-7.7L7 8.62M5.03 12.5l2.83-.78m-1.97 3.9 2.83-.78"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.446 17a1 1 0 0 0 .66 1.22l2.86.78a1.94 1.94 0 0 0 2.43-1.32l2.79-9.37a2 2 0 0 0-1.37-2.41l-2.85-.83a1 1 0 0 0-1.22.66z"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M19.89 10.185a.375.375 0 0 1 0-.75m0 .75a.375.375 0 0 0 0-.75m-1.719 5.61a.375.375 0 0 1 0-.75m0 .75a.375.375 0 0 0 0-.75"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m10.54 10.93-.97-6.1m3.14 8.35 1.47-7.35"
  })));
};
export default SvgAccordion;